import { Box, type BoxProps, Button, useTheme } from "@mui/material";
import { Phone } from "lucide-react";
import type { FC } from "react";
import { AdvisorMessagesButton } from "web_myplann/Advisor/Components/AdvisorMessagesButton";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPhoneHref } from "web_myplann/Shared/Utils/getPhoneHref";

type Props = Omit<BoxProps, "children"> & {
	phone?: string;
	unreadCount: number;
	onOpenChat: () => void;
};

export const AdvisorActionButtons: FC<Props> = ({
	phone,
	unreadCount,
	onOpenChat,
	...boxProps
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Box
			display="grid"
			gridAutoFlow="column"
			gridAutoColumns="minmax(0, 1fr)"
			gap={theme.spacingTokens.sm}
			width="100%"
			{...boxProps}
		>
			{phone && (
				<Button
					variant="primary"
					startIcon={<Phone size={theme.iconSize.sm} />}
					component="a"
					href={getPhoneHref(phone)}
				>
					{t(Resources.Advisor.call)}
				</Button>
			)}
			<AdvisorMessagesButton unreadCount={unreadCount} onClick={onOpenChat} />
		</Box>
	);
};
